import React from 'react'
import adData from '../../../json/icao-ad.json';

export default function CivilAdDisplay(){
    const CivilAd=adData.map((aerodromes)=>{
        return aerodromes.civil.map(civil =>{
            return(
                <tr>
                    <td>{civil.id}</td>
                    <td>{civil.icao}</td>

                    <td>{civil.name}</td>
                    <td>{civil.latitude}</td>
                    <td>{civil.longitude}</td>
                </tr>
                )
            }
        )}
    )

    return(
        <div>
            <table className="table table-striped">
                <thead>
                    <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>ICAO</th>
                    <th>latitude</th>
                    <th>longitude</th>
                    </tr>
                </thead>
                <tbody>
                    {CivilAd}                    
                </tbody>
            </table>
             
        </div>
    )
 }